import type {
    CommandActiveStoreType,
    CommandItemModelType,
    CommandActiveState
} from "./type";

export const createCommandStore = (): CommandActiveStoreType => {
    const listeners = new Set<() => void>();

    let items: Array<CommandItemModelType> = [];

    let activeKey: string | undefined;

    let isRingVisible = true;

    const getActiveItem = () => items.find((item) => item.key === activeKey) ?? items[0];

    return {
        setActive: (props) => {
            if(activeKey === props.activeKey && isRingVisible === props.isRingVisible) {
                return;
            }

            activeKey = props.activeKey;

            isRingVisible = props.isRingVisible;

            listeners.forEach((listener) => {
                listener();
            });
        },
        getItemState: (key: string): CommandActiveState => {
            if(getActiveItem()?.key !== key) {
                return 0;
            }

            return isRingVisible ? 2 : 1;
        },
        getActiveId: () => getActiveItem()?.id,
        subscribe: (listener) => {
            listeners.add(listener);

            return () => {
                listeners.delete(listener);
            };
        },
        setItems: (nextItems) => {
            items = nextItems;
        },
        getActiveItem
    };
};
